module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="list">\n</div>\n<hr/>\n<a href="#" class="button button-secondary newFile">\n  Add a new file\n</a>\n<a href="#" class="button button-secondary existingFile">\n  Add a file you uploaded previously\n</a>\n<div class="modal"></div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./base/templates/attachments/layout.html
// module id = 282
// module chunks = 0